import { Phone } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";
import { TEL_LINK, waLink, DEFAULT_MSG } from "@/constants/site";

const FloatingBar = () => (
  <div
    className="fixed bottom-0 inset-x-0 z-40 grid grid-cols-2 md:hidden border-t border-white/10"
    data-testid="mobile-floating-dispatch-bar"
  >
    <a
      href={TEL_LINK}
      data-testid="floating-call-button"
      className="pulse-ring flex items-center justify-center gap-2 bg-emergency py-4 font-display text-base font-bold uppercase tracking-wider text-white active:bg-emergency-dark"
    >
      <Phone className="h-5 w-5" /> Call Dispatch
    </a>
    <a
      href={waLink(DEFAULT_MSG)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-button"
      className="pulse-ring-green flex items-center justify-center gap-2 bg-dispatch py-4 font-display text-base font-bold uppercase tracking-wider text-white active:bg-dispatch-dark"
    >
      <FaWhatsapp className="h-5 w-5" /> WhatsApp / Text
    </a>
  </div>
);

export default FloatingBar;
